import { createFileRoute, Outlet } from "@tanstack/react-router";
import { OrganisationsProvider } from "~/contexts/OrganisationsProvider";

export const Route = createFileRoute("/_app/settings/organisations")({
  component: OrganisationsRoute,
});

function OrganisationsRoute() {
  return (
    <OrganisationsProvider>
      <Outlet />
    </OrganisationsProvider>
  );
}
